import React from 'react';
import PropTypes from 'prop-types';
import sharedStyle from '../../styles/shared.css';
import styles from './styles.css';


const FormMessage = ({ title, subTitle }) => (
  <div className={styles.formMessage}>
    <p className={sharedStyle.formTitle}>
      {title}
    </p>
    <p className={sharedStyle.formSubTitle}>
      {subTitle}
    </p>
  </div>
);

FormMessage.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

FormMessage.defaultProps = {
  title: 'This is a title',
  subTitle: 'This is a sub-title',
};

export default FormMessage;
